import React, { useState, useEffect } from "react";
import { Table, Button, Space, Tooltip, Typography, Tag } from "antd";
import { PlayCircleOutlined, PauseCircleOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import recording from "../../../../services/recording"
import { notify } from "../../../../utils/helper";
import styled from "styled-components";
import AttachSecriptModal from "./AttachSecriptModal";
import { CustomButton } from "../../physician_page/styled";
import VideoDetailModal from "../../videos_container/VideoDetailModal";

const { Text } = Typography;

export const ExpandedTableWrapper = styled.div`
  .ant-table-container{
    height: fit-content;
  }
  .ant-table{
    overflow: auto scroll;
  }
`;

const RecordingsTable = ({ scriptId, recordingFileUrl, recordingFileName, getRecordingFileFromS3, search }) => {
  const [recordingData, setRecordingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openAttachScriptModal, setOpenAttachScriptModal] = useState(false);
  const [selectedRecording, setSelectedRecording] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoDetailModalVisible, setVideoDetailModalVisible] = useState(false);


  const fetchAudioFiles = async () => {
    try {
      setLoading(true);
      const res = await recording.getRecording(scriptId);
      const processedData = processRecordingData(res?.data?.recordings || []);
      setRecordingData(processedData);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching recordings:", err);
      setLoading(false);
    }
  };

  const processRecordingData = (data) => {
    // console.log("data", data);
    return data.map((item) => ({
      ...item,
      key: item.id,
      recordingTitle: capitalizeFirstLetter(item.name || "Untitled Recording"),
      createdAt: moment(item?.createdAt).format("DD-MMM-YYYY hh:mm A"),
      // createdBy: item?.createdBy?.name || item?.user?.name,
      status: capitalizeFirstLetter(item?.status) || "pending",
      recordingBy: item?.user?.email || "Unknown",
    }));
  };

  useEffect(() => {
    if (scriptId) {
      fetchAudioFiles();
    }
  }, [scriptId]);

  const handleApproveOrReject = async (recordingId, status) => {
    try {
      setLoading(true);
      const res = await recording.recordingApproveOrReject(recordingId,
        { status: status }
      );
      notify("success", `Recording ${capitalizeFirstLetter(res?.data?.recording?.status)}  Successfully.`);
      fetchAudioFiles();
      setLoading(false);
    } catch (error) {
      console.error("Error approving recording:", error);
    }
  };

  const handleOpenVideoDetailModal = (videoData) => {
    setSelectedVideo(videoData);
    setVideoDetailModalVisible(true);
    setOpenAttachScriptModal(false);
  };

  const handleCloseVideoDetailModal = () => {
    setVideoDetailModalVisible(false);
    setSelectedVideo(null);
    setOpenAttachScriptModal(false);
  };

  const columns = [
    {
      title: "Recording Title",
      dataIndex: "recordingTitle",
      key: "recordingTitle",
      width: 200,
    },
    {
      title: "Recording",
      key: "recording",
      align: "center",
      width: 200,
      render: (_, record) => (
        <div className="d-flex justify-content-center gap-12">
          {recordingFileUrl && recordingFileName === record?.recording && (
            <audio
              controls
              autoPlay
              src={recordingFileUrl}
              style={{ maxWidth: "200px" }}
            />
          )}
          <Button
            type="default"
            size="small"
            style={{ color: "var(--primary-text-color)" }}
            icon={
              recordingFileUrl && recordingFileName === record?.recording ? (
                <PauseCircleOutlined />
              ) : (
                <PlayCircleOutlined />
              )
            }
            onClick={() => getRecordingFileFromS3(record?.recording)}
          >
            {recordingFileUrl && recordingFileName === record?.recording ? "Pause" : "Play"}
          </Button>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
      width: 200,
    },
    {
      title: "Recorded `By",
      dataIndex: "recordingBy",
      key: "recordingBy",
      // width: "200px",
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      width: 200,
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    // {
    //   title: "Created By",
    //   dataIndex: "createdBy",
    //   key: "createdBy",
    //   width: "15%",
    // },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      width: "10%",
      render: (_, record) => (
        <Space size="small">
          {record?.status !== "Approved" && record?.status !== "Rejected" ? (
            <>
              <Tooltip title="Approve Recording">
                <Button
                  type="text"
                  size="small"
                  // icon={<CheckOutlined />}
                  onClick={() => handleApproveOrReject(record.id, "approved")}
                  disabled={record.status === "approved"}
                  style={{ padding: "0 19px" }}
                >
                  <CheckOutlined className="font-17" style={{ color: "#46b648" }} />
                </Button>
              </Tooltip>
              <Tooltip title="Reject Recording">
                <Button
                  type="danger"
                  size="small"
                  // icon={<CloseOutlined />}
                  onClick={() => handleApproveOrReject(record.id, "rejected")}
                  disabled={record.status === "rejected"}
                  style={{ padding: "0 19px" }}
                >
                  <CloseOutlined className="font-17" style={{ color: "#e91d26" }} />
                </Button>
              </Tooltip>
            </>
          ) : (
            <div>
              {record?.status === "Approved" ? (
                <div style={{display:'flex'}}>
               <CustomButton
                  type="secondary"
                style={{marginRight : '10px'}}
                  size="small"
                onClick={() => {
                  setSelectedRecording(record);
                  setOpenAttachScriptModal(!openAttachScriptModal);
                }}
                // disabled={record.status === "approved"}
                >Use Recording</CustomButton>
                <Button
                  type="primary"
                  size="small"
                  style={{color: "var(--primary-text-color)"}}
                // onClick={() => handleApproveOrReject(record.id, "approved")}
                // disabled={record.status === "approved"}
                >Clean Recording</Button>
                </div>
              ) : ("-")}

              
            </div>
          )}
        </Space>
      ),
    },
  ];

  const filteredData = () => {

    if(!search) return recordingData;

    return recordingData.filter((item) => item?.name.toLowerCase().includes(search.toLowerCase()))
  };

  return (
    <ExpandedTableWrapper>
      {
        openAttachScriptModal && (
          <AttachSecriptModal 
            open={openAttachScriptModal} 
            setOpen={setOpenAttachScriptModal} 
            selectedRecording={selectedRecording}
            recordingFileUrl={recordingFileUrl}
            recordingFileName={recordingFileName}
            getRecordingFileFromS3={getRecordingFileFromS3}
            handleOpenModal={handleOpenVideoDetailModal}
            />
        )
      }
      {videoDetailModalVisible && (
        <VideoDetailModal
          visible={videoDetailModalVisible}
          setVisible={setVideoDetailModalVisible}
          onClose={handleCloseVideoDetailModal}
          videoData={selectedVideo}
          selectedRecording={selectedRecording}
          recordingFileUrl={recordingFileUrl}
          recordingFileName={recordingFileName}
          getRecordingFileFromS3={getRecordingFileFromS3}
          setOpen={handleCloseVideoDetailModal}
        />
      )}
      <div style={{ margin: "16px 0", height: "fit-content" }}>
        <Table
          style={{ height: "fit-content" }}
          columns={columns}
          dataSource={filteredData()}
          loading={loading}
          size="small"
          pagination={false}
          scroll={recordingData.length > 0 ? { x: "max-content" } : null}
          locale={{
            emptyText: "No recordings found for this script",
          }}
        />
      </div>
    </ExpandedTableWrapper>
  );
};

export default RecordingsTable;